import { AuthenticationService } from '../../../core/services/authentication.service';
import { BaseFormComponent } from '../base-form/base-form.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ScreenCaptureService } from '../../../core/services/screen-capture.service';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';

@Component({
	selector: 'app-mp-camera',
	templateUrl: './mp-camera.component.html',
	styleUrls: ['./mp-camera.component.scss']
})
export class MpCameraComponent extends BaseFormComponent implements OnInit {

	@Output() cancel: EventEmitter<any> = new EventEmitter();
	@Output() proceed: EventEmitter<any> = new EventEmitter();
	@Input() numberOfPictures = 1;
	@Input() facingMode: string = facingModeEnum.user;  // Set front camera
	@Input() isLoanLiveliness: boolean;
	@Input() loading: boolean;
	@Input() errorMessage: string;
	showCamera: boolean;
	showWebcam = true;
	allowCameraSwitch = true;
	multipleWebcamsAvailable = false;
	deviceId: string;
	videoOptions: MediaTrackConstraints = {
		// width: {ideal: 1024},
		// height: {ideal: 576}
		facingMode: { ideal: this.facingMode }
	};
	errors: WebcamInitError[] = [];
	// latest snapshot
	webcamImage: WebcamImage = null;
	// webcam snapshot trigger
	private trigger: Subject<void> = new Subject<void>();
	// switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
	private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();
	snapShots: WebcamImage[] = [];
	filesArr: any[] = [];



	constructor(
		private captureService: ScreenCaptureService,
		private auth: AuthenticationService,
		public fb: FormBuilder
	) {
		super(fb);
	}

	ngOnInit(): void {
		this.showCamera = this.isLoanLiveliness ? true : false;
		WebcamUtil.getAvailableVideoInputs()
			.then((mediaDevices: MediaDeviceInfo[]) => {
				this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
			});
	}

	submit() {
		const obj: { files: any, snapshots: any; } = { files: this.filesArr, snapshots: this.snapShots };
		this.proceed.emit(obj);
	}

	removePhoto(photo: WebcamImage) {
		const index = this.snapShots.findIndex(x => photo.imageAsDataUrl === x.imageAsDataUrl);
		this.snapShots.splice(index, 1);
	}

	triggerSnapshot(): void {
		this.trigger.next();
	}

	clearShots() {
		this.snapShots = [];
	}

	toggleWebcam(): void {
		this.showWebcam = !this.showWebcam;
	}

	handleInitError(error: WebcamInitError): void {
		this.errors.push(error);
	}

	showNextWebcam(directionOrDeviceId: boolean | string): void {
		// true => move forward through devices
		// false => move backwards through devices
		// string => move to device with given deviceId
		this.nextWebcam.next(directionOrDeviceId);
	}

	handleImage(webcamImage: WebcamImage): void {
		this.webcamImage = webcamImage;
		const image = webcamImage;
		const imgFile = this.captureService.base64ToFile(webcamImage.imageAsDataUrl, 'image.jpg');
		this.snapShots.push(image);
		this.filesArr.push(imgFile);
	}

	cameraWasSwitched(deviceId: string): void {
		this.deviceId = deviceId;
	}

	get triggerObservable(): Observable<void> {
		return this.trigger.asObservable();
	}

	get nextWebcamObservable(): Observable<boolean | string> {
		return this.nextWebcam.asObservable();
	}
}

export enum facingModeEnum {
	user = 'user',
	environment = 'environment'
}
